"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M21 0H3v24h18zm-7 22h-4v-1h4zm5.25-3H4.75V3h14.5z"
}), 'TabletAndroidSharp');